import { tokenFormatter } from '@/lib/formatting';

import { TokenAvatar } from '@/ui/Avatars/TokenAvatar';

import { TokenResult } from '@/utils/0x/token-registry.types';

export function CompletedTradeAmountCell({
  amount,
  symbol,
  token,
}: {
  amount: number;
  symbol: string | undefined;
  token: TokenResult | undefined;
}) {
  return (
    <span className="flex items-center">
      {token && (
        <TokenAvatar
          address={token.address}
          chainId={token.chainId}
          alt={`${token.name} logo`}
          size={16}
          showChainLogo={false}
          className="mr-1"
        />
      )}
      {tokenFormatter.format(amount, { symbol })}
    </span>
  );
}
